<template>
    <div class="bg">
        <v-container fluid>
            <v-row class="mx-10 mt-6" justify="center">
                <v-card width="650">
                    <v-toolbar style="background-color: #0d2155;">
                        <v-toolbar-title class="text-white">
                            <img style="min-width: 315px; position: absolute; margin-top: -10px;" class="" width="315"
                                height="25" src="../img/partner-dell-white.png" />
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="white" class="text-none">
                            <LanguagePlaceholder default-text="Languages" />
                            <v-menu activator="parent" transition="scale-transition" location="bottom">
                                <v-list>
                                    <v-list-item v-for="(item, index) in languageItems" :key="index" :value="index"
                                        @click="selectLanguage(item)">
                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="">
                        <v-row>
                            <v-col>
                                <v-window v-model="processWindow">
                                    <v-window-item value="enter-username">
                                        <v-card>
                                            <v-card-title>
                                                <LanguagePlaceholder default-text="Forgotten Password" />
                                            </v-card-title>
                                            <v-card-text>
                                                <div>
                                                    <div>
                                                        <p>
                                                            <LanguagePlaceholder is-html :element-visible="processWindow == 'enter-username'"
                                                                default-text="Please follow the on screen instructions to reset your password." />
                                                        </p>
                                                        <br />
                                                        <p>
                                                            <LanguagePlaceholder is-html :element-visible="processWindow == 'enter-username'"
                                                                default-text="If you have forgotten your password or exceeded your log-in attempts, please enter your business email address that you would have registered to the program with below. We will then send you an email containing an otp. Please enter the otp where prompted in order to verify your email address." />
                                                        </p>
                                                        <br>
                                                        <p>
                                                            <v-text-field v-model="forgotPasswordUsername"
                                                                prepend-inner-icon="mdi-email-outline" class=""
                                                                variant="outlined"
                                                                density="comfortable"
                                                                >
                                                                <template v-slot:label>
                                                                    <LanguagePlaceholder default-text="Username (Business email address)" :element-visible="processWindow == 'enter-username'" />
                                                                </template>
                                                            </v-text-field>
                                                        </p>
                                                        <p>
                                                            <LanguagePlaceholder is-html :element-visible="processWindow == 'enter-username'"
                                                                default-text="Unsure of your business email address registered to the account? Contact support@dellpartnerincentives.com." />
                                                        </p>
                                                        <br />
                                                        <p>
                                                            <vue-hcaptcha sitekey="776658a4-c4ba-4c88-8c98-de0a61104618"
                                                                @verify="updateCaptchaToken">
                                                            </vue-hcaptcha>
                                                        </p>

                                                    </div>
                                                </div>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn @click="goTo('login')" class="my-2 text-none" width="100"
                                                    variant="tonal"><LanguagePlaceholder default-text="Cancel" :element-visible="processWindow == 'enter-username'" /></v-btn>
                                                <v-btn :disabled="!usernameVerified" class="text-none"
                                                    @click="clickSubmitForgotPasswordUsername" color="#2a6fc3"
                                                    width="100" variant="elevated">
                                                    <LanguagePlaceholder default-text="Submit" :element-visible="processWindow == 'enter-username'" />
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>

                                    </v-window-item>
                                    <v-window-item value="enter-otp">
                                        <v-card>
                                            <v-card-title>
                                                Forgotten Password
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <div>Please enter the 6 digit OTP that was sent to {{
                                        forgotPasswordUsername }}</div>
                                                <div>
                                                    <v-otp-input autofocus v-model="otpInput" focus-all
                                                        @finish="otpFinishForgotPassword" :length="6"></v-otp-input>
                                                </div>
                                                <div>
                                                    <v-btn class="my-2 text-none" @click="cancelLogin" width="100"
                                                        variant="tonal">Cancel</v-btn>
                                                </div>
                                            </v-card-text>

                                        </v-card>
                                    </v-window-item>
                                    <v-window-item value="create-password">
                                        <v-card>
                                            <v-card-title>
                                                Forgotten Password
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <div>
                                                    <PasswordStrength class="mt-2" v-model="newPassword"
                                                        :min-characters="12" @passwordValidated="passwordValidated"
                                                        inner-icon="mdi-lock-outline"
                                                        place-holder="Enter your password" />

                                                </div>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn class="my-2 text-none" @click="cancelLogin" width="100"
                                                    variant="tonal">Cancel</v-btn>
                                                <v-btn :disabled="!passwordsValidated" class="text-none"
                                                    @click="clickSubmitCreatePasswordForgotPassword" color="#2a6fc3"
                                                    width="100" variant="elevated">
                                                    Submit
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-window-item>

                                </v-window>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-row>
        </v-container>

        <v-footer height="45" color="#212529" padless app>
            <v-row justify="center" no-gutters>
                <v-btn variant="text" @click="systemStore.routerTo('noauth-terms-of-use')"
                    class="my-2 mx-2 text-white text-none">
                    <LanguagePlaceholder is-html position="fixed"
                        default-text="Terms Of Use" />
                </v-btn>
                <v-btn variant="text" @click="systemStore.routerTo('noauth-privacy-statement')"
                    class="my-2 mx-2 text-white text-none">
                    <LanguagePlaceholder  is-html position="fixed"
                        default-text="Privacy Statement" />
                </v-btn>
                <v-btn variant="text" @click="systemStore.routerTo('noauth-cookies-information')"
                    class="my-2 mx-2 text-white text-none">
                    <LanguagePlaceholder is-html position="fixed"
                        default-text="Cookies Information" />
                </v-btn>
            </v-row>
        </v-footer>
    </div>


</template>

<script setup>
import router from '../router'
import { ref, onMounted, computed } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import PasswordStrength from '@/components/PasswordStrength.vue'


import { useSystemStore } from '@/stores/system'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()
const systemStore = useSystemStore()

const processWindow = ref('captcha')
const forgotPasswordUsername = ref('')
const newPassword = ref('')
const passwordsValidated = ref(false)
const otpInput = ref('')

const captchaToken = ref('')
const captchaSuccess = ref(false)

const usernameVerified = computed(() => {
    if (forgotPasswordUsername.value.trim().length > 0 && captchaSuccess.value === true) {
        return true
    } else {
        return false
    }
})

const cancelLogin = () => {
    systemStore.routerTo('login')
}

onMounted(() => {
    processWindow.value = 'enter-username'
})

const updateCaptchaToken = (token, ekey) => {
    authStore.hCaptchaSiteVerify(token).then(res => {
        captchaSuccess.value = res.success
    })
}

const clickSubmitForgotPasswordUsername = () => {
    authStore.sendEmailVerificationOtp(forgotPasswordUsername.value).then(res => {
        if (res.success == true) {
            processWindow.value = 'enter-otp'
        } else {
            // show error message
        }
    })
}

const otpFinishForgotPassword = () => {
    authStore.verifyOtpEmailForgotPassword(otpInput.value, forgotPasswordUsername.value).then(res => {
        if (res.success) {
            processWindow.value = 'create-password'
        } else {
            otpInput.value = ''
        }
    })
}

const passwordValidated = (validated) => {
    passwordsValidated.value = validated
}

const clickSubmitCreatePasswordForgotPassword = () => {
    const bla = newPassword.value
    authStore.submitForgotPasswordUpdate(forgotPasswordUsername.value, newPassword.value, otpInput.value).then(res => {
        if (res.success == true) {
            goTo('login')
        } else {
            // show error message
        }
    })
}

const languageItems = [
    { title: 'Français', language: 'FRANCAIS' },
    { title: 'Deutsch', language: 'DEUTSCH' },
    { title: 'Español', language: 'ESPANOL' },
    { title: 'Italiano', language: 'ITALIANO' },
    { title: 'English', language: 'ENGLISH' },
    { title: 'Polski', language: 'POLSKI' },
    { title: 'Türkçe', language: 'TURKISH' },
]

const icons = [
    'mdi-home',
    'mdi-email',
    'mdi-calendar',
    'mdi-delete'
]

const links = [
    { text: '© Dell Technologies 2024', enabled: false },
    { text: 'Terms Of Use', enabled: true },
    { text: 'Privacy Statement', enabled: true },
    { text: 'Cookies Information', enabled: true },
    { text: 'Contact', enabled: true }
]

const goTo = (routeName) => {
    if (routeName !== undefined) {
        router.push({ name: routeName })
    }
}

</script>

<style scoped>
.bg {
    width: 100%;
    height: calc(100%);
    background: url('../img/login-bg.jpg');
    background-size: cover;
}
</style>